import React, { useState } from 'react';

import { Input, Button, ProgressBar } from '../../styles';
import { GridContainer, GridCell } from '../../grid';
import { findLatLng } from '../../../tools/location';

function PositionForm({
  position,
  myPosition,
  address,
  handleChange,
  variant,
  buttonText,
}) {
  const [processing, setProcessing] = useState(false);

  async function getPosition() {
    setProcessing(true);
    const location = await findLatLng(address);
    handleChange('position', location);
    setProcessing(false);
  }

  if (variant === 'hiddenLatLng') {
    return (
      <Button palette='primary' onClick={() => getPosition()} disabled={processing}>
        {buttonText || 'Generate Latitude and Longitude'}
      </Button>
    );
  }

  return (
    <div>
      <GridContainer>
        <GridCell weight={1}>
          <Input
            name="lat"
            palette='secondary'
            label="Latitude"
            type="number"
            value={position?.lat || ''}
            onChange={(value) => handleChange('lat', value)}
          />
        </GridCell>
        <GridCell weight={1}>
          <Input
            name="lng"
            palette='secondary'
            label="Longitude"
            type="number"
            value={position?.lng || ''}
            onChange={(value) => handleChange('lng', value)}
          />
        </GridCell>
        {(address && address !== '') &&
          <GridCell style={{ marginTop: 7 }}>
            <Button palette='primary' onClick={() => getPosition()} disabled={processing}>
              {buttonText || 'Generate Latitude and Longitude'}
            </Button>
            {processing && <ProgressBar />}
          </GridCell>
        }
      </GridContainer>
    </div>
  );
}

export default PositionForm;

